import React, { useEffect } from "react";
import { Gap, RefreshButton } from "../../atoms";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { getTableKelurahan } from "../../../config/Redux/ExcoKelurahan/actions";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/constansColors";
import { getKabKot, getKecamatan } from "../../../config/Redux/Global/actions";
import Pagination from "@mui/material/Pagination";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import ExcoCardView from "../../molecules/ExcoCardView";
import "../../molecules/ExcoCardView/ExcoFilter.css";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const ExcoKelurahan = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [search, setsearch] = React.useState("");
  const [sortBy, setSortBy] = React.useState("nama_kantor");
  const [sortType, setSortType] = React.useState("asc");
  const [filterProvince, setProvince] = React.useState("0");
  const [filterCities, setCities] = React.useState("0");
  const [filterKecamatan, setKecamatan] = React.useState("0");
  // const dataExcoKecamatan = useSelector((state) => state.excokecamatan.dataKecamatan);
  const dataExcoKelurahan = useSelector(
    (state) => state.excokelurahan.dataKelurahan,
  );
  const listProvinsi = useSelector((state) => state.global.dataProvince);
  const listKabkot = useSelector((state) => state.global.dataKabKot);
  const listKecamatan = useSelector((state) => state.global.dataKecamatan);
  const provinces = [
    { kode_prov_bps: 0, nama_prov_kemdagri: "Semua Provinsi" },
  ];
  const cities = [
    { kode_kab_kota_bps: 0, nama_kab_kota_kemdagri: "Semua Kab/Kota" },
  ];
  const kecamatan = [{ kode_kec_bps: 0, nama_kec_bps: "Semua Kecamatan" }];

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let levelExco = profile?.data?.id_tingkat_exco;
  let profileProvince = profile?.data?.id_provinsi;
  let profileKabKot = profile?.data?.id_kabkot;
  let profileKecamatan = profile?.data?.id_kecamatan;
  if (levelExco === 1) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      provinces.push(listProvinsi.data[i]);
    }
    for (let i = 0; i < listKabkot.data?.length; i++) {
      cities.push(listKabkot.data[i]);
    }
    for (let i = 0; i < listKecamatan.data?.length; i++) {
      kecamatan.push(listKecamatan.data[i]);
    }
  } else if (levelExco === 2) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      if (profileProvince === listProvinsi.data[i].kode_prov_bps) {
        provinces.push(listProvinsi.data[i]);
      }
    }
    for (let i = 0; i < listKabkot.data?.length; i++) {
      // if(profileProvince === listKabkot.data[i].kode_prov_bps){
      cities.push(listKabkot.data[i]);
      // }
    }
    for (let i = 0; i < listKecamatan.data?.length; i++) {
      kecamatan.push(listKecamatan.data[i]);
    }
  } else if (levelExco === 3) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      if (profileProvince === listProvinsi.data[i].kode_prov_bps) {
        provinces.push(listProvinsi.data[i]);
      }
    }
    for (let i = 0; i < listKabkot.data?.length; i++) {
      if (profileKabKot === listKabkot.data[i].kode_kab_kota_bps) {
        cities.push(listKabkot.data[i]);
      }
    }
    for (let i = 0; i < listKecamatan.data?.length; i++) {
      kecamatan.push(listKecamatan.data[i]);
    }
  } else if (levelExco === 4) {
    for (let i = 0; i < listProvinsi.data?.length; i++) {
      if (profileProvince === listProvinsi.data[i].kode_prov_bps) {
        provinces.push(listProvinsi.data[i]);
      }
    }
    for (let i = 0; i < listKabkot.data?.length; i++) {
      if (profileKabKot === listKabkot.data[i].kode_kab_kota_bps) {
        cities.push(listKabkot.data[i]);
      }
    }
    for (let i = 0; i < listKecamatan.data?.length; i++) {
      if (profileKecamatan === listKecamatan.data[i].kode_kec_bps) {
        kecamatan.push(listKecamatan.data[i]);
      }
    }
  }

  // for(let i=0; i<listProvinsi.data?.length;i++){
  //   provinces.push(listProvinsi.data[i])
  // }
  // for(let i=0; i<listKabkot.data?.length;i++){
  //   cities.push(listKabkot.data[i])
  // }
  const handlePagination = async (event, value) => {
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", value);
    } else {
      url.searchParams.append("page", value);
    }
    window.history.pushState({}, null, url);

    setCurrentPage(value);
    setLoading(true);
    let a = await dispatch(
      getTableKelurahan(
        `kelurahan`,
        value,
        search,
        sortBy,
        sortType,
        filterProvince,
        filterCities,
        filterKecamatan,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      var url_string = window.location.href;
      var url = new URL(url_string);
      var page = url.searchParams.get("page");
      var sort_type = url.searchParams.get("sort_type");
      var sort_by = url.searchParams.get("sort_by");
      var search_by = url.searchParams.get("search_by");
      var province = url.searchParams.get("province");
      var city = url.searchParams.get("city");
      var kec = url.searchParams.get("kecamatan");

      if (province) {
        dispatch(getKabKot(province));
        setProvince(province);
      }
      if (city) {
        dispatch(getKecamatan(`provinsi=${province}&kotaKab=${city}`));
        setCities(city);
      }
      if (kec) {
        setKecamatan(kec);
      }
      setsearch(search_by);

      // Check if data already exists in Redux (cache check)
      const currentCachePage = dataExcoKelurahan?.data?.current_page;
      const requestedPage = page ? parseInt(page) : 1;

      // Skip API call if data exists and page matches, and no active search/param filters
      if (
        dataExcoKelurahan?.data?.data?.length &&
        currentCachePage === requestedPage &&
        !search_by &&
        !province &&
        !city &&
        !kec
      ) {
        setCurrentPage(requestedPage);
        return;
      }

      setLoading(true);
      if (page) {
        setCurrentPage(parseInt(page));
        let a = await dispatch(
          getTableKelurahan(
            `kelurahan`,
            page,
            search_by,
            sort_by,
            sort_type,
            province,
            city,
            kec,
          ),
        );
        if (a) {
          setLoading(false);
        }
      } else {
        let a = await dispatch(
          getTableKelurahan(
            `kelurahan`,
            1,
            search_by,
            sort_by,
            sort_type,
            province,
            city,
            kec,
          ),
        );
        if (a) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [
    dispatch,
    dataExcoKelurahan?.data?.current_page,
    dataExcoKelurahan?.data?.data?.length,
  ]);

  const handleSelectProv = async (event) => {
    var url = new URL(window.location.href);
    var province = url.searchParams.get("province");
    if (province) {
      url.searchParams.set("province", event.target.value);
    } else {
      url.searchParams.append("province", event.target.value);
    }
    window.history.pushState({}, null, url);

    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", 1);
    } else {
      url.searchParams.append("page", 1);
    }
    window.history.pushState({}, null, url);
    setProvince(event.target.value);
    setCities("0");
    setKecamatan("0");
    setLoading(true);
    if (event.target.value !== "0") {
      dispatch(getKabKot(event.target.value));
      setCurrentPage(1);
      let a = await dispatch(
        getTableKelurahan(
          `kelurahan`,
          1,
          search,
          sortBy,
          sortType,
          event.target.value,
        ),
      );
      if (a) {
        setLoading(false);
      }
    } else {
      let a = await dispatch(
        getTableKelurahan(`kelurahan`, 1, search, sortBy, sortType),
      );
      if (a) {
        setLoading(false);
      }
    }
  };
  const handleSelectCities = async (event) => {
    var url = new URL(window.location.href);
    var city = url.searchParams.get("city");
    if (city) {
      url.searchParams.set("city", event.target.value);
    } else {
      url.searchParams.append("city", event.target.value);
    }
    window.history.pushState({}, null, url);

    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", 1);
    } else {
      url.searchParams.append("page", 1);
    }
    window.history.pushState({}, null, url);

    setCurrentPage(1);
    setCities(event.target.value);
    setKecamatan("0");
    setLoading(true);
    if (event.target.value !== "0") {
      dispatch(
        getKecamatan(
          `provinsi=${filterProvince}&kotaKab=${event.target.value}`,
        ),
      );
      setCurrentPage(1);
      let a = await dispatch(
        getTableKelurahan(
          `kelurahan`,
          1,
          search,
          sortBy,
          sortType,
          filterProvince,
          event.target.value,
        ),
      );
      if (a) {
        setLoading(false);
      }
    } else {
      let a = await dispatch(
        getTableKelurahan(
          `kelurahan`,
          1,
          search,
          sortBy,
          sortType,
          filterProvince,
        ),
      );
      if (a) {
        setLoading(false);
      }
    }

    // let a = await dispatch(getTableKelurahan(`kelurahan`,1,search,sortBy,sortType,filterProvince,event.target.value));
    // if(a){
    //   setLoading(false)
    // }
  };
  const handleSelectKecamatan = async (event) => {
    var url = new URL(window.location.href);
    var keca = url.searchParams.get("kecamatan");
    if (keca) {
      url.searchParams.set("keca", event.target.value);
    } else {
      url.searchParams.append("keca", event.target.value);
    }
    window.history.pushState({}, null, url);

    var page = url.searchParams.get("page");
    if (page) {
      url.searchParams.set("page", 1);
    } else {
      url.searchParams.append("page", 1);
    }
    window.history.pushState({}, null, url);

    setCurrentPage(1);
    setKecamatan(event.target.value);
    setLoading(true);
    if (event.target.value !== "0") {
      let a = await dispatch(
        getTableKelurahan(
          `kelurahan`,
          1,
          search,
          sortBy,
          sortType,
          filterProvince,
          filterCities,
          event.target.value,
        ),
      );
      if (a) {
        setLoading(false);
      }
    } else {
      let a = await dispatch(
        getTableKelurahan(
          `kelurahan`,
          1,
          search,
          sortBy,
          sortType,
          filterProvince,
          filterCities,
        ),
      );
      if (a) {
        setLoading(false);
      }
    }

    // let a = await dispatch(getTableKelurahan(`kelurahan`,1,search,sortBy,sortType,filterProvince,event.target.value));
    // if(a){
    //   setLoading(false)
    // }
  };
  const handleSearch = async (event) => {
    setsearch(event.target.value);
    let temp = event.target.value;
    var timeout;
    var delay = 500;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(async () => {
      if (temp === event.target.value) {
        var url = new URL(window.location.href);
        var search_by = url.searchParams.get("search_by");
        if (search_by || search_by === "") {
          url.searchParams.set("search_by", event.target.value);
        } else {
          url.searchParams.append("search_by", event.target.value);
        }
        window.history.pushState({}, null, url);

        var page = url.searchParams.get("page");
        if (page) {
          url.searchParams.set("page", 1);
        } else {
          url.searchParams.append("page", 1);
        }
        window.history.pushState({}, null, url);

        setLoading(true);
        let a = await dispatch(
          getTableKelurahan(
            `kelurahan`,
            1,
            event.target.value,
            sortBy,
            sortType,
            filterProvince,
            filterCities,
            filterKecamatan,
          ),
        );
        if (a) {
          setLoading(false);
        }
        setCurrentPage(1);
      }
    }, delay);
  };
  const handleSort = async (event) => {
    var url = new URL(window.location.href);
    var sort_by = url.searchParams.get("sort_by");
    if (sort_by) {
      url.searchParams.set("sort_by", event.target.value);
    } else {
      url.searchParams.append("sort_by", event.target.value);
    }
    window.history.pushState({}, null, url);

    setSortBy(event.target.value);
    setLoading(true);
    let a = await dispatch(
      getTableKelurahan(
        `kelurahan`,
        currentPage,
        search,
        event.target.value,
        sortType,
        filterProvince,
        filterCities,
        filterKecamatan,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };
  const handleSortType = async (event) => {
    var url = new URL(window.location.href);
    var sort_type = url.searchParams.get("sort_type");
    if (sort_type) {
      url.searchParams.set("sort_type", event.target.value);
    } else {
      url.searchParams.append("sort_type", event.target.value);
    }
    window.history.pushState({}, null, url);

    setSortType(event.target.value);
    setLoading(true);
    let a = await dispatch(
      getTableKelurahan(
        `kelurahan`,
        currentPage,
        search,
        sortBy,
        event.target.value,
        filterProvince,
        filterCities,
        filterKecamatan,
      ),
    );
    if (a) {
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    const response = await dispatch(
      getTableKelurahan(
        `kelurahan`,
        currentPage,
        search,
        sortBy,
        sortType,
        filterProvince,
        filterCities,
        filterKecamatan,
      ),
    );
    if (response) {
      setLoading(false);
    }
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <Gap height={20} />

      {/* Page Header with Title and Refresh */}
      <div className="exco-page-header">
        <h1 className="exco-page-title">EXCO Kelurahan/Desa</h1>
        <div className="exco-refresh-wrapper">
          <RefreshButton
            onClick={handleRefresh}
            loading={loading}
            loadingLabel={window.innerWidth < 1400 ? "" : "Memuat..."}
          />
        </div>
      </div>
      <Gap height={20} />

      {/* Filter Row */}
      <div className="exco-filter-row">
        <select
          className="exco-filter-dropdown"
          onChange={handleSelectProv}
          value={filterProvince}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          {provinces.map((list, key) => (
            <option value={list.kode_prov_bps} key={key}>
              Provinsi: {list.nama_prov_kemdagri}
            </option>
          ))}
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSelectCities}
          value={filterCities}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          {cities.map((list, key) => (
            <option value={list.kode_kab_kota_bps} key={key}>
              Kab/Kot: {list.nama_kab_kota_kemdagri}
            </option>
          ))}
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSelectKecamatan}
          value={filterKecamatan}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          {kecamatan.map((list, key) => (
            <option value={list.kode_kec_bps} key={key}>
              Kecamatan: {list.nama_kec_bps}
            </option>
          ))}
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSort}
          value={sortBy}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          <option value="nama_kantor">Urutkan: Nama Kelurahan</option>
        </select>

        <select
          className="exco-filter-dropdown"
          onChange={handleSortType}
          value={sortType}
          style={{
            maxWidth: "none",
            minWidth: "150px",
            flexGrow: 1,
            boxSizing: "border-box",
            height: "36px",
            padding: "0 26px 0 10px",
            fontSize: "13px",
          }}
        >
          <option value="asc">A-Z (Ascending)</option>
          <option value="desc">Z-A (Descending)</option>
        </select>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            padding: "0 10px",
            maxWidth: "none",
            minWidth: "200px",
            flexGrow: 4,
            boxSizing: "border-box",
            height: "36px",
          }}
        >
          <SearchIcon style={{ color: "#9CA3AF", marginRight: "8px" }} />
          <input
            type="text"
            placeholder="Search by kelurahan/desa"
            value={search || ""}
            onChange={handleSearch}
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              fontSize: "13px",
              color: "#1a1a1a",
              background: "transparent",
            }}
          />
        </div>
      </div>

      <ExcoCardView
        loading={loading}
        data={dataExcoKelurahan?.data?.data}
        currentPage={currentPage}
        type="kelurahan"
        nameExco="EXCO Kelurahan/Desa"
      />
      {dataExcoKelurahan?.data?.data?.length > 0 && (
        <div
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "10px",
          }}
        >
          <Pagination
            count={Math.ceil(dataExcoKelurahan?.data?.total_items / 10)}
            variant="outlined"
            shape="rounded"
            page={currentPage}
            onChange={handlePagination}
            className={classes.root}
          />
        </div>
      )}
      <Gap height={20} />
      <div className="footer-content"></div>
    </div>
  );
};

export default ExcoKelurahan;
